export default {
  title01: "Тренутно време",
  title02: "24 часа",
  title03: "Погледај 10-дневну прогнозу",
  title04: "AQI",
  title05: "Погледај све информације",
  title06: "ИЗЛАЗАК И ЗАЛАЗАК СУНЦА",
  title07: "ФАЗА МЕСЕЦА",
  title08: "Следећи пун Месец",
  title09: "Следећи млади Месец",
  title10: "ДАН",
  title11: "НОЋ",
  title12: "Излазак Сунца",
  title13: "Залазак Сунца",
  title14: "Излазак Месеца",
  title15: "Залазак Месеца",
  title16: "Извор",
  title17: "Почетак",
  title18: "Крај",
  title19: "Користи тренутну локацију",
  title20: "Претражи град",
  title21: "Осећа се као",
  title22: "Осећа се као у сенци",
  title23: "Сада",
  title24: "Данас",
  title25: "НЕД",
  title26: "ПОН",
  title27: "УТО",
  title28: "СРЕ",
  title29: "ЧЕТ",
  title30: "ПЕТ",
  title31: "СУБ",
  title32: "Учитавање...",
  title33: "Сада",
  title34: "На сат времена",
  title35: "Дан",
  title36: "Сунце и Месец",
  title37: "Квалитет ваздуха",
  title38: "Контакт: xlf550402@gmail.com",
  title39: "Политика приватности",
  title40: "Ауторска права © comfortweather.com 2020 - 2026. Сва права задржана.",
  title41: "Подаци обезбеђени од стране",
  title42: "Maks",
  title43: "Min",
  title44: "Прихватам",
  title45:
    "Хвала вам што користите ComfortWeather! Да бисте боље заштитили своја законска права и интересе, молимо вас да пажљиво прочитате ",
  title46: "Политику приватности",
  title47: " пре употребе.",
  title48: "",
  title49: "Контакт: xyjph123@gmail.com",
  title50: "Ауторска права © 24hweather.com 2020 - 2026. Сва права задржана.",
  title51:
    "Хвала вам што користите 24hweather! Да бисте боље заштитили своја законска права и интересе, молимо вас да пажљиво прочитате ",
  title52: "Otkrivena je promena vaše lokacije. Želite li da je ažurirate?",
  title53: "Potvrdi",
  title54: "Otkaži",
  title55: "Nazad",
  title56: "Vesti",
  title57: "Ažuriranje vremena...",
  title58: "Vreme je ažurirano",
  title59: "Prikaži sve",
  title60: "Ауторска права © mobi321.com 2020 - 2026. Сва права задржана.",
  title61: "Juče",
  title62: "Sutra",
  title63: "Погледај 15-дневну прогнозу",
  title64: "Današnji detalji",
  title65: "Rahu Kaal",
  title66: "Indeksi životnog stila",
  title67: "Indeksi životnog stila",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Teško se suši",
  title103: "Sporo sušenje",
  title104: "Dobro se suši",
  title105: "Brzo sušenje",
  title106: "Veoma brzo sušenje",

  title107: "Nepotpuno prikladno",
  title108: "Skromno iskustvo",
  title109: "Dobro za vodene aktivnosti",
  title110: "Veoma prikladno",
  title111: "Savršeni uslovi",

  title112: "Podsticajno za zdravlje",
  title113: "Neutralni uslovi",
  title114: "Blago veći rizik",
  title115: "Visok rizik",
  title116: "U ekstremnom riziku",

  title117: "Nepotpuno prikladno",
  title118: "Delimično prikladno",
  title119: "Dobro za aktivnosti na otvorenom",
  title120: "Veoma prikladno",
  title121: "Izvrsni uslovi",

  title122: "Veoma suvi uslovi",
  title123: "Verovatno suvo",
  title124: "Blago suvo",
  title125: "Malo verovatno suvo",
  title126: "Veoma malo verovatno suvo",

  title127: "Nije preporučeno",
  title128: "Prihvatljivo",
  title129: "Dobar dan",
  title130: "Veoma dobri uslovi",
  title131: "Idealni uslovi",
};
